module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"navMenu":{"headerMyAccount":"My account","headerLinks":"Compare and switch","headerGuides":"Guides","headerNewsroom":"Newsroom","headerLatestArticles":"Latest articles"}}}')
  delete Component.options._Ctor
}
